import React from "react";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

// Telr requires the cardholder to accept the terms before a charge is
// authorised, so every path that reaches the gateway gates its pay button on
// this. The terms open in a new tab so a half-filled form is never navigated
// away from, and the disabled button is the only prompt needed — no error line
// before the client has done anything wrong.
function TermsCheckbox({ checked, onChange, disabled, sx, suffix }) {
  return (
    <FormControlLabel
      sx={{ ml: 0, mr: 0, alignItems: "center", ...sx }}
      disabled={disabled}
      control={<Checkbox size="small" checked={checked} onChange={(e) => onChange(e.target.checked)} sx={{ p: 0.75, mr: 0.5 }} />}
      label={
        <Typography variant="body2">
          I agree to the{" "}
          <Link href="/legal/terms" target="_blank" rel="noopener noreferrer" sx={{ fontWeight: 600 }}>
            Terms &amp; Conditions
          </Link>
          {suffix ? ` ${suffix}` : ""}
        </Typography>
      }
    />
  );
}

export default TermsCheckbox;
